import { PlanInterface } from './../../../models/plan.model';
import { Component, inject ,signal} from '@angular/core';
import { ActivatedRoute , UrlSegment} from '@angular/router';
import { BaseList } from '../../../shared/baseList.component';
import { MateriaInterface } from '../../../models/materia.model';
import { MateriasPlanService } from '../../../core/materiasPlan.service';
import { MATERIAS_FIELDS_CONFIG, MATERIAS_ACTIONS, MATERIAS_PLAN_COLUMN_NAMES, MATERIAS_ACTIONS_POR_PLAN, MATERIAS_POR_PLAN_ACTIONS_DELETED, MATERIAS_POR_PLAN_PAGINATE_OPTIONS } from '../../../constants/materias.constants';
import { Table } from '../../../shared/components/table/table.component';
import { Titledescription } from '../../../shared/components/titledescription/titledescription.component';
import { Button } from '../../../shared/components/button/button.component';
import { MateriasService } from '../../../core/materias.service';
import { PlanesService } from '../../../core/planes.service';
import { COMPETENCIAS_ACTIONS_DELETED } from '../../../constants/competencias.constants';
import { DEFAULT_PAGINATE_OPTIONS_LIST, PaginateOptions } from '../../../utils/paginate.utils';

@Component({
  selector: 'app-materias',
  standalone: true,
  imports: [Table,Titledescription,Button],
  templateUrl: './materias-por-plan.component.html',
  styleUrl: './materias-por-plan.component.css'
})
export class MateriasPorPlanComponent extends BaseList<MateriaInterface> {
  planService = inject(PlanesService);
  apiService = inject(MateriasPlanService);
  materiaService = inject(MateriasService);
  backUrl = signal('');
  columnNames = MATERIAS_PLAN_COLUMN_NAMES;
  fields = MATERIAS_FIELDS_CONFIG;
  actions = MATERIAS_ACTIONS_POR_PLAN;
  actionsDeletedItems = MATERIAS_POR_PLAN_ACTIONS_DELETED
  paginateOptions = MATERIAS_POR_PLAN_PAGINATE_OPTIONS;
  planId!: number;
  override valueToFilter: any = null;
  entityKey = 'materiasPorPlan';
  planData:PlanInterface | null = null;
  constructor() {
    super();
    const activatedRoute = inject(ActivatedRoute);
    activatedRoute.params.subscribe((params) => {
      this.planId = Number(params['id']);
      this.fieldToFilter = 'plan.id';
      this.valueToFilter = this.planId;
      this.planService.getById(this.planId).subscribe(data => {
        this.planData = data as PlanInterface;
      });
    });
    activatedRoute.url.subscribe((UrlSegment: UrlSegment[])=>{
      this.backUrl.set(UrlSegment[0].path);
    });
  }

  override ngOnDestroy(): void {
    this.fieldToFilter = '';
    this.valueToFilter = null;
  }
  // getMateriasByPlan = (data: PaginateOptions = { ...DEFAULT_PAGINATE_OPTIONS_LIST }, ignoreCache: boolean = false) => {
  //     return this.apiService.getMateriasByPlan(this.planId, data, ignoreCache);
  // }
}
